<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important;" class="main">
    <v-flex xs12 style="overflow-y: hidden;">
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="startTimeRegistration" class="breadCrumb">
        Time registration
      </v-btn>
      <v-btn @click="selectEmployee(currentEmployee)" class="breadCrumb" v-if="showTimeRegistrations || showTimeRegistration">
        {{ currentEmployee.name }}
      </v-btn>

      <div style="float: right;">
        <v-btn @click="previousTimeRegistrationPeriod" class="pageTimeRegistrationBtn" style="margin-right: 10px;" v-if="showTimeRegistrations">
          &lt;
        </v-btn>
        <v-btn @click="nextTimeRegistrationPeriod" class="pageTimeRegistrationBtn" style="margin-right: 50px !important;" v-if="showTimeRegistrations">
          &gt;
        </v-btn>

        <v-btn @click="startNewTimeRegistration" class="newTimeRegistrationBtn" v-if="showNewTimeRegistration">
          New time registration
        </v-btn>
        <v-btn @click="startTimeRegistration" class="endTimeRegistrationBtn" v-if="showTimeRegistrations">
          Logout
        </v-btn>
      </div>
    </v-flex>
    <v-container fluid py-2 px-3 v-show="showEmployeeList" class="employeeButtons">
      <v-layout style="max-height: calc(100vh - 190px);">
        <v-flex xs12 style="overflow-y: auto;">
          <v-flex xs12 v-for="(employee, i) in employees" :key="i" :style="'height: ' + Math.min(20, Math.max(6, 65 / employees.length)) + 'vh; min-height: 5vh !important; margin-bottom: ' + (Math.max(0.5, 8 / employees.length)) + 'vh !important;'" class="employeeButton">
            <v-btn @click="selectEmployee(employee)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / employees.length)) + 'vh !important; min-height: 5vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - (5 * employees.length), 14), 25) + 'pt !important;'">{{ employee.name }}</v-btn>
          </v-flex>
          <div style="padding-top: 20vh; width: 100%; text-align: center; font-size: 20px;" v-show="employees.length === 0">No employees found</div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-if="showEmployee" class="employeeContainer">
      <v-layout style="max-height: calc(100vh - 160px); padding-top: 16px;">
        <v-flex xs12 v-if="showLoginDialog" style="text-align: center;">
          <table class="numberPad">
            <tr>
              <td colspan="3">
                <div class="header">Enter access code</div>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <div class="errorMessage" v-if="errorMessage !== ''">{{ errorMessage }}</div>
                <div class="numberPadValue" v-if="errorMessage === ''">{{ currentAccessCode }}</div>
              </td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
              <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
              <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
              <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
              <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
              <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
              <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="clear()">Clr</div></td>
              <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
              <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 3.5vh;">keyboard_backspace</v-icon></div></td>
            </tr>
          </table>
        </v-flex>

        <v-flex xs12 style="overflow-y: auto; text-align: center;" v-if="showTimeRegistrations">
          <table class="timeRegistrations">
            <tr>
              <th style="width: 120px;">Date</th>
              <th style="width: 100px;">Start time</th>
              <th style="width: 100px;">End time</th>
              <th style="width: 100px; text-align: center;">Break</th>
              <th style="width: 100px; text-align: center;">Total</th>
              <th style="width: 30%;">Field</th>
              <th>Task</th>
            </tr>
            <tr v-for="(timeRegistration, i) in timeRegistrations" v-bind:key="timeRegistration.id" @click="selectTimeRegistration(timeRegistration)" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main">{{ timeRegistration.displayDate }}</td>
              <td class="main" style="padding-left: 20px;">{{ timeRegistration.displayStartTime }}</td>
              <td class="main" style="padding-left: 10px;">{{ timeRegistration.displayEndTime }}</td>
              <td class="main" style="text-align: right; padding-right: 15px;">{{ breakAsString(timeRegistration.lunchBreak) }}</td>
              <td class="main" style="text-align: right; padding-right: 15px;">{{ durationAsString(timeRegistration.duration) }}</td>
              <td class="main"><div v-if="timeRegistration.field" v-html="timeRegistration.field.address.nameAndText"></div></td>
              <td class="main"><div v-if="timeRegistration.task" v-html="timeRegistration.task.title"></div></td>
            </tr>
            <tr class="total" v-if="timeRegistrations && timeRegistrations.length">
              <td class="total" colspan="4">Total</td>
              <td class="total" style="text-align: right; padding-right: 15px;">{{ durationAsString(totalDuration) }}</td>
              <td class="total" colspan="2"></td>
            </tr>
            <tr class="empty" v-if="!timeRegistrations || timeRegistrations.length === 0">
              <td class="empty" colspan="7">No time registrations found from {{ toDateDanish(timeRegistrationFromDate) }} to {{ toDateDanish(timeRegistrationToDate) }}</td>
            </tr>
          </table>
        </v-flex>

        <v-flex xs12 v-if="showTimeRegistration" class="timeRegistration">
          <Panel title="Time registration">
            <PanelColumn>
              <v-flex xs12 sm4 md3 lg2 style="line-height: 44px;">
                <v-label>Start time</v-label>
              </v-flex>
              <v-flex xs12 sm8 md9 lg10 style="line-height: 36px;">
                <table>
                  <tr>
                    <td>
                      <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-btn flat class="dateButton" v-on="on"><v-icon>event</v-icon>&nbsp;&nbsp;<div style="width: 100px;">{{ toDateDanish(startDate) }}</div></v-btn>
                        </template>
                        <v-date-picker v-model="startDate" @input="startDateMenu = false"></v-date-picker>
                      </v-menu>
                    </td>
                    <td style="padding-left: 25px;">
                      <v-menu v-model="startTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-btn flat class="timeButton" v-on="on"><v-icon>access_time</v-icon>&nbsp;&nbsp;<div style="width: 55px;">{{ startTime }}</div></v-btn>
                        </template>
                        <v-time-picker v-if="startTimeMenu" v-model="startTime" :allowed-minutes="startAllowedSteps" class="mt-3" format="24hr" @click:minute="startTimeMenu = false"></v-time-picker>
                      </v-menu>
                    </td>
                  </tr>
                </table>
              </v-flex>

              <v-flex xs12 sm4 md3 lg2 style="line-height: 44px;">
                <v-label>End time</v-label>
              </v-flex>
              <v-flex xs12 sm8 md9 lg10 style="line-height: 36px;">
                <table>
                  <tr>
                    <td>
                      <v-menu v-model="endDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-btn flat class="dateButton" v-on="on"><v-icon>event</v-icon>&nbsp;&nbsp;<div style="width: 100px;">{{ toDateDanish(endDate) }}</div></v-btn>
                        </template>
                        <v-date-picker v-model="endDate" @input="endDateMenu = false"></v-date-picker>
                      </v-menu>
                    </td>
                    <td style="padding-left: 25px;">
                      <v-menu v-model="endTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-btn flat class="timeButton" v-on="on"><v-icon>access_time</v-icon>&nbsp;&nbsp;<div style="width: 55px;">{{ endTime }}</div></v-btn>
                        </template>
                        <v-time-picker v-if="endTimeMenu" v-model="endTime" :allowed-minutes="endAllowedSteps" class="mt-3" format="24hr" @click:minute="endTimeMenu = false"></v-time-picker>
                      </v-menu>
                    </td>
                  </tr>
                </table>
              </v-flex>

              <v-flex xs12 sm4 md3 lg2 style="line-height: 44px;">
                <v-label>Break</v-label>
              </v-flex>
              <v-flex xs12 sm8 md9 lg10 style="line-height: 36px;">
                <table style="width: 100%;">
                  <tr>
                    <td style="width: 150px; vertical-align: top;">
                      <v-btn flat class="lunchBreakButton"><div style="width: 100px;">{{ currentTimeRegistration.lunchBreak }} minutes</div></v-btn>
                    </td>
                    <td>
                      <v-slider hide-details v-model="currentTimeRegistration.lunchBreak" step="5" max="180" ticks style="margin-top: 25px;"/>
                    </td>
                  </tr>
                </table>
              </v-flex>

              <v-flex xs12 sm4 md3 lg2 py-2>
                <v-label>Field</v-label>
              </v-flex>
              <v-flex xs12 sm8 md9 lg10 py-2 class="field">
                <v-select :items="fields" v-model="currentTimeRegistration.field" item-text="address.nameAndText" return-object class="timeRegistrationField"></v-select>
              </v-flex>

              <v-flex xs12 sm4 md3 lg2 py-2>
                <v-label>Task</v-label>
              </v-flex>
              <v-flex xs12 sm8 md9 lg10 py-2 class="task">
                <v-select :items="tasks" v-model="currentTimeRegistration.task" item-text="title" return-object class="timeRegistrationTask"></v-select>
              </v-flex>

              <v-flex xs12 py-2 style="text-align: right;">
                <v-btn class="timeRegistrationButton" style="float: left;" @click="confirmDeleteTimeRegistration" v-if="currentTimeRegistration.id">Delete</v-btn>
                <v-btn class="timeRegistrationButton" @click="saveTimeRegistration">Save</v-btn>
                <v-btn class="timeRegistrationButton" @click="cancelTimeRegistration">Cancel</v-btn>
              </v-flex>
            </PanelColumn>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="confirmDeleteTimeRegistrationDialog" attach=".employeeContainer" width="35vw" v-if="showEmployee">
      <v-card pa-5>
        <v-card-title class="headline">Delete time registration</v-card-title>
        <v-card-text>Are you sure you want to delete this time registration?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteTimeRegistration" class="bw-3">Yes</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="confirmDeleteTimeRegistrationDialog = false" class="bw-3">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import DateUtil from '@/assets/javascript/dateutil'
import axios from 'axios'

export default {
  name: 'TodoTimeRegistration',
  components: { Panel, PanelColumn, ErrorDialog },
  data () {
    return {
      employees: [],
      currentEmployee: null,
      timeRegistrationFromDate: '',
      timeRegistrationToDate: '',
      timeRegistrations: [],
      currentTimeRegistration: null,
      startDate: '',
      startTime: '',
      startDateMenu: false,
      startTimeMenu: false,
      endDate: '',
      endTime: '',
      endDateMenu: false,
      endTimeMenu: false,
      fields: [],
      tasks: [],
      loggedIn: false,
      currentAccessCode: '',
      errorMessage: '',
      confirmDeleteTimeRegistrationDialog: false,
      intervalId: null,
      logoutCounter: 0,
      updateCounter: 0
    }
  },
  created: function () {
    this.startTimeRegistration()
    let _this = this
    this.intervalId = setInterval(function () {
      _this.checkLogout()
    }, 1000)
  },
  destroyed: function () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  computed: {
    showEmployeeList: function () {
      return !this.showFrontPage && !this.currentEmployee
    },
    showEmployee: function () {
      return !this.showFrontPage && this.currentEmployee !== null
    },
    showLoginDialog: function () {
      return this.showEmployee && !this.loggedIn
    },
    loginButtonEnabled: function () {
      return this.currentAccessCode.length === 4
    },
    isLoggedIn: function () {
      return this.loggedIn
    },
    showTimeRegistrations: function () {
      return this.showEmployee && this.isLoggedIn && !this.currentTimeRegistration
    },
    showTimeRegistration: function () {
      return this.showEmployee && this.isLoggedIn && this.currentTimeRegistration
    },
    showNewTimeRegistration: function () {
      return this.showTimeRegistrations
    },
    totalDuration: function () {
      if (this.timeRegistrations && this.timeRegistrations.length) {
        let totalDuration = 0
        for (let timeregistration of this.timeRegistrations) {
          if (timeregistration.duration && timeregistration.duration > 0) {
            totalDuration += timeregistration.duration
          }
        }
        return totalDuration
      }
      return null
    }
  },
  methods: {
    startAllowedSteps: m => m % 5 === 0,
    endAllowedSteps: m => m % 5 === 0,
    gotoFrontPage () {
      this.currentEmployee = null
      this.logout()
      this.$parent.$parent.gotoHome()
    },
    startTimeRegistration () {
      this.currentEmployee = null
      this.logout()
      this.loadEmployees()
    },
    loadEmployees () {
      axios.get('/backend/rest/employee')
        .then(response => {
          this.employees = response.data
        })
    },
    async selectEmployee (employee) {
      if (!this.currentEmployee || this.currentEmployee.id !== employee.id) {
        this.logout()
      }
      this.currentEmployee = employee

      // Load time registrations for the employee
      let from = new Date()
      let fromTime = DateUtil.datetimeToString(from)
      await axios.get('/backend/rest/time_registration/period/current')
        .then(response => {
          fromTime = response.data
        })
      this.timeRegistrationFromDate = DateUtil.datetimeToDate(fromTime)
      let to = new Date(this.timeRegistrationFromDate.valueOf())
      to.setMonth(to.getMonth() + 1)
      to.setDate(to.getDate() - 1)
      let toTime = DateUtil.datetimeToString(to)
      this.timeRegistrationToDate = DateUtil.datetimeToDate(toTime)

      await this.loadTimeRegistrations()
      this.loadFields()
      this.loadTasks()
    },
    async previousTimeRegistrationPeriod () {
      this.clearLogoutCounter()
      let from = DateUtil.timeStringToDate(this.timeRegistrationFromDate)
      from.setMonth(from.getMonth() - 1)
      let fromTime = DateUtil.datetimeToString(from)
      this.timeRegistrationFromDate = DateUtil.datetimeToDate(fromTime)
      let to = new Date(this.timeRegistrationFromDate.valueOf())
      to.setMonth(to.getMonth() + 1)
      to.setDate(to.getDate() - 1)
      let toTime = DateUtil.datetimeToString(to)
      this.timeRegistrationToDate = DateUtil.datetimeToDate(toTime)

      await this.loadTimeRegistrations()
    },
    async nextTimeRegistrationPeriod () {
      this.clearLogoutCounter()
      let from = DateUtil.timeStringToDate(this.timeRegistrationFromDate)
      from.setMonth(from.getMonth() + 1)
      let fromTime = DateUtil.datetimeToString(from)
      this.timeRegistrationFromDate = DateUtil.datetimeToDate(fromTime)
      let to = new Date(this.timeRegistrationFromDate.valueOf())
      to.setMonth(to.getMonth() + 1)
      to.setDate(to.getDate() - 1)
      let toTime = DateUtil.datetimeToString(to)
      this.timeRegistrationToDate = DateUtil.datetimeToDate(toTime)

      await this.loadTimeRegistrations()
    },
    loadFields () {
      axios.get('/backend/rest/field/time_registration')
        .then(response => {
          this.fields = response.data
        })
        .catch(() => {
          this.fields = []
        })
    },
    loadTasks () {
      axios.get('/backend/rest/employee/task')
        .then(response => {
          this.tasks = response.data
        })
        .catch(() => {
          this.tasks = []
        })
    },
    login () {
      if (this.currentEmployee && this.currentAccessCode.length === 4) {
        let employee = JSON.parse(JSON.stringify(this.currentEmployee))
        employee.accessCode = this.currentAccessCode
        axios.post('/backend/rest/employee/login', employee)
          .then(response => {
            this.loggedIn = true
            this.errorMessage = ''
            this.clearLogoutCounter()
          })
          .catch(() => {
            this.errorMessage = 'Access code it not valid'
            this.currentAccessCode = ''
          })
      }
    },
    logout () {
      this.loggedIn = false
      this.currentAccessCode = ''
      this.errorMessage = ''
      this.currentTimeRegistration = null
    },
    loadTimeRegistrations () {
      if (this.currentEmployee) {
        axios.get('/backend/rest/time_registration/employee/' + this.currentEmployee.id + '?from=' + this.timeRegistrationFromDate + '&to=' + this.timeRegistrationToDate)
          .then(response => {
            this.timeRegistrations = response.data
          })
          .catch(() => {
            this.timeRegistrations = []
          })
      }
    },
    numberClick: function (number) {
      if (this.currentAccessCode.length < 4) {
        this.currentAccessCode = this.currentAccessCode + '' + number
        this.errorMessage = ''
      }
      this.login()
    },
    clear: function () {
      this.currentAccessCode = ''
      this.errorMessage = ''
    },
    backspace: function () {
      let val = '' + this.currentAccessCode
      if (val.length > 1) {
        this.currentAccessCode = val.substring(0, val.length - 1)
      } else {
        this.clear()
      }
      this.errorMessage = ''
    },
    startNewTimeRegistration () {
      this.clearLogoutCounter()
      this.currentTimeRegistration = {
        id: null,
        employee: this.currentEmployee,
        field: null,
        task: null,
        startTime: '',
        endTime: '',
        lunchBreak: 0,
        duration: 0
      }
      let now = new Date()
      let minutes = Math.floor(now.getTime() / 60000)
      let minutesRounded = Math.round(minutes / 5) * 5
      now.setTime(minutesRounded * 60000)
      let startDateTime = DateUtil.datetimeToString(now)
      this.startDate = DateUtil.datetimeToDate(startDateTime)
      this.startTime = DateUtil.datetimeToTime(startDateTime)
      this.endDate = ''
      this.endTime = ''
    },
    selectTimeRegistration (timeRegistration) {
      this.clearLogoutCounter()
      this.currentTimeRegistration = timeRegistration
      this.startDate = DateUtil.datetimeToDate(this.currentTimeRegistration.startTime)
      this.startTime = DateUtil.datetimeToTime(this.currentTimeRegistration.startTime)
      this.endDate = DateUtil.datetimeToDate(this.currentTimeRegistration.endTime)
      this.endTime = DateUtil.datetimeToTime(this.currentTimeRegistration.endTime)
    },
    saveTimeRegistration () {
      this.clearLogoutCounter()
      this.currentTimeRegistration.startTime = this.startDate + ' ' + this.startTime
      this.currentTimeRegistration.endTime = this.endDate + ' ' + this.endTime
      axios.post('/backend/rest/time_registration', this.currentTimeRegistration)
        .then(response => {
          this.loadTimeRegistrations()
        })
      this.currentTimeRegistration = null
    },
    confirmDeleteTimeRegistration () {
      this.clearLogoutCounter()
      this.confirmDeleteTimeRegistrationDialog = true
    },
    deleteTimeRegistration () {
      this.clearLogoutCounter()
      axios.delete('/backend/rest/time_registration/' + this.currentTimeRegistration.id)
        .then(() => {
          this.confirmDeleteTimeRegistrationDialog = false
          this.currentTimeRegistration = null
          this.loadTimeRegistrations()
        })
    },
    cancelTimeRegistration () {
      this.clearLogoutCounter()
      this.currentTimeRegistration = null
    },
    breakAsString (breakMinutes) {
      let breakAsString = ''
      if (breakMinutes && breakMinutes > 0) {
        breakAsString = breakMinutes + ' min'
      }
      return breakAsString
    },
    durationAsString (durationMinutes) {
      let durationAsString = ''
      if (durationMinutes && durationMinutes > 0) {
        durationAsString = (durationMinutes / 60).toFixed(2) + ' hrs'
      }
      return durationAsString
    },
    checkLogout () {
      if (this.logoutCounter > 0) {
        this.logoutCounter--
        if (this.logoutCounter === 0) {
          this.startTimeRegistration()
        }
      }
    },
    clearLogoutCounter () {
      this.logoutCounter = 180
    },
    toDateDanish (dateTime) {
      return DateUtil.datetimeToDateDanish(dateTime)
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .employeeButton {
  }
  .errorMessage {
    color: red;
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 6vh;
    width: 100%;
    cursor: pointer;
    font-size: 2vh;
    line-height: 6vh;
    text-align: center;
    padding: 0 10px;
  }
  .numberPad {
    position: absolute;
    left: calc(50% - 15vh);
    top: 24vh;
    width: 30vh;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 0.3vh;
    text-align: right;
    width: 20%;
  }
  .numberPad tr td.wide {
    width: 40%;
  }
  .numberPadValue {
    -webkit-text-security: disc;
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 6vh;
    width: 100%;
    cursor: pointer;
    font-size: 8vh;
    line-height: 7vh;
    text-align: center;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .numberBtn {
    width: 100%;
    height: 6vh;
    text-align: center;
    vertical-align: center;
    line-height: 6vh;
    font-size: 3vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .loginBtn {
    width: 100%;
    height: 6vh;
    text-align: center;
    vertical-align: center;
    line-height: 6vh;
    font-size: 3vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .disabled {
    background-color: #DDDDDD;
    cursor: default;
    color: #AAAAAA;
  }
  label {
    font-size: 110% !important;
  }
  input {
    font-size: 110% !important;
  }
  table.timeRegistrations {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 16px;
  }
  table.timeRegistrations th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.timeRegistrations td {
    text-align: left;
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 3px 5px;
    cursor: pointer;
  }
  tr.odd {
    background-color: #ffffff;
  }
  tr.odd:hover {
    background-color: #fafafa;
  }
  tr.even {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.even:hover {
    background-color: rgba(0, 77, 64, 0.05);
  }
  tr.total,
  td.total {
    font-weight: bold;
    border-top: 2px solid #004d40;
    border-bottom: 2px solid #004d40;
    cursor: default !important;
  }
  tr.empty,
  td.empty {
    text-align: center !important;
    padding: 20px !important;
    border-top: 2px solid #004d40;
    border-bottom: 2px solid #004d40;
    cursor: default !important;
  }
  div.header {
    text-align: center;
    font-size: 2.5vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoTimeRegistration.vue